/**
 * @Name: 展会首页store
 */
import services from '../../services'
const state = {
    pageInfo: {
        curPage: 1,
        pageSize: 8,
        totalRows: 20
    },
    pageVO: {
        curPage: 1,
        pageSize: 8
    },
    meeting: [],
    paramHotel: {
        dataRang: []
    }
}
const getters = {
}
const actions = {

    /**
     * 获取展会首页列表
     */
    getExhiHomeList(context, param) {
        return new Promise((resolve, reject) => {
            services.homeSer.getExhiHomeList(param).then((res) => {
                context.commit('setExhiHomeList', res || [])
                resolve()
            })
        })
    },

    /**
     *  获取热门酒店轮播图展示
     */
    getHotHotel(context, param) {
        return new Promise((resolve, reject) => {
            services.homeSer.getHotHotel(param).then((res) => {
                resolve(res.data.data)
            })
        })
    }
}
const mutations = {
    setParamHotel(state, payload) {
        state.paramHotel = payload
    },

    /**
     * 设置展会首页列表数据
     * @param {*} state
     * @param {*} payload
     */
    setExhiHomeList(state, payload) {
        state.meeting = payload.data.data
        state.pageInfo = payload.data.pageInfo
    },

    /**
     * 设置分页信息
     */
    setPageVO(state, { curPage, pageSize }) {
        curPage && (state.pageVO.curPage = curPage)
        pageSize && (state.pageVO.pageSize = pageSize)
    }

}

export default {
    state,
    namespaced: true,
    getters,
    actions,
    mutations
}
